import styled from 'styled-components';
import { fontSmoothing } from '@finect/tabular-utils/fontSmoothing';
import { getFont } from '@finect/tabular-utils/getFont';
export var LinkBlockButton = styled.div.withConfig({
  displayName: "linkControlComponents__LinkBlockButton",
  componentId: "sc-124ye3b-0"
})(["position:absolute;z-index:3;top:15px;left:50%;border-radius:", ";background:", ";transform:translateX(-50%) translateY(-100%);"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiLL;
});
export var EnterURL = styled.div.withConfig({
  displayName: "linkControlComponents__EnterURL",
  componentId: "sc-124ye3b-1"
})(["width:290px;max-width:100%;padding:15px;border-radius:", ";box-shadow:", ";background:", ";", ";", ";color:#fff;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.borderRadius;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.boxShadow;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.uiDD;
}, getFont(0, 'compact'), fontSmoothing);
export var InputField = styled.div.withConfig({
  displayName: "linkControlComponents__InputField",
  componentId: "sc-124ye3b-2"
})(["position:relative;&:last-of-type{margin-bottom:6px;}svg{position:absolute;top:8px;left:", ";opacity:0.75;}"], function (_ref6) {
  var iconLeftPosition = _ref6.iconLeftPosition;
  return iconLeftPosition ? iconLeftPosition : '1px';
});
export var Input = styled.input.withConfig({
  displayName: "linkControlComponents__Input",
  componentId: "sc-124ye3b-3"
})(["position:relative;z-index:1;width:100%;padding:3px 0 3px 27px;border-bottom:1px solid rgba(255,255,255,0.1);margin-bottom:9px;font-family:", ";", ";color:", ";&:focus{border-color:rgba(255,255,255,0.5);}::placeholder{opacity:0.5;padding:0 3px;color:#fff;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
}, getFont(0), function (_ref8) {
  var error = _ref8.error,
    theme = _ref8.theme;
  return error ? theme.colors.warn : '#fff';
});
export var Cancel = styled.div.withConfig({
  displayName: "linkControlComponents__Cancel",
  componentId: "sc-124ye3b-4"
})(["opacity:0.75;margin-right:12px;cursor:pointer;"]);